import React from 'react';
import PropTypes from 'prop-types';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import moment from 'moment';
import groupBy from 'lodash/groupBy';

const DetailNudgesModal = ({ detailNudgesFilter, detailNudges, detailNudgesDescription, setDetailNudgesFilter }) => {
  const detailNudgesSublist = detailNudgesList =>
    detailNudgesList.map((row, index) => (
      <div key={row.id} className={`${index > 0 ? 'border-top' : ''} py-2`}>
        <div className="font-weight-bold">{row.title}</div>
        <div className="text-muted">{row.description}</div>
      </div>
    ));

  const detailNudgesBody = () => {
    if (detailNudges.length === 0) {
      return <div className="text-center p-4">No nudges found.</div>;
    }

    const detailNudgesGroupedByUser = Object.entries(
      groupBy(
        detailNudges,
        ({
          user: {
            person: { identifier },
          },
        }) => identifier
      )
    );
    if (detailNudgesFilter.user_id) {
      const groupByCreatedAt = detailNudgesFilter.recommendation_status === 'open';

      if (groupByCreatedAt) {
        const three_day_threshold = moment().subtract(3, 'day');
        const seven_day_threshold = moment().subtract(7, 'day');

        const recommendations_less_than_3_days_old = detailNudges.filter(
          rec => !rec.created_at || moment(rec.created_at) > three_day_threshold
        );
        const recommendations_more_than_3_less_than_7_days_old = detailNudges.filter(
          rec =>
            rec.created_at &&
            moment(rec.created_at) <= three_day_threshold &&
            moment(rec.created_at) > seven_day_threshold
        );
        const recommendations_more_than_7_days_old = detailNudges.filter(
          rec => rec.created_at && moment(rec.created_at) <= seven_day_threshold
        );

        return (
          <div>
            {detailNudgesSublist(recommendations_less_than_3_days_old)}
            {recommendations_more_than_3_less_than_7_days_old.length > 0 && (
              <div className="mt-4 text-warning">3+ days old</div>
            )}
            {detailNudgesSublist(recommendations_more_than_3_less_than_7_days_old)}
            {recommendations_more_than_7_days_old.length > 0 && <div className="mt-4 text-danger">7+ days old</div>}
            {detailNudgesSublist(recommendations_more_than_7_days_old)}
          </div>
        );
      }

      return detailNudgesSublist(detailNudges);
    }

    return detailNudgesGroupedByUser.map(([userIdentifier, detailNudgesForUser]) => (
      <div className="mt-4 mb-5 border-bottom" key={userIdentifier}>
        <h5 className="preview-user-label border-bottom pb-2 mb-0">{`${userIdentifier}`}</h5>
        {detailNudgesForUser.map((row, index) => (
          <div key={row.id} className={`${index > 0 ? 'border-top' : ''} py-2`}>
            <div className="font-weight-bold">{row.title}</div>
            <div className="text-muted">{row.description}</div>
          </div>
        ))}
      </div>
    ));
  };

  return (
    <Modal
      className="sales-assist-modal"
      isOpen={!!detailNudgesFilter}
      toggle={() => setDetailNudgesFilter(null)}
      style={{ width: '1200px', maxWidth: '90vw' }}
    >
      <ModalHeader toggle={() => setDetailNudgesFilter(null)}>{detailNudgesDescription}</ModalHeader>
      <ModalBody className="nudgebot-analytics-modal">{detailNudgesBody()}</ModalBody>
    </Modal>
  );
};

DetailNudgesModal.propTypes = {
  setDetailNudgesFilter: PropTypes.func.isRequired,
  detailNudgesDescription: PropTypes.string.isRequired,
  detailNudgesFilter: PropTypes.shape({
    user_id: PropTypes.number,
  }).isRequired,
  detailNudges: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default DetailNudgesModal;
